import { NotificationType, Settings } from '%services/settings';

export function reducer(prevState: Settings, action: Action): Settings {
	switch (action.type) {
		case 'LOAD_SETTINGS':
			return {
				...prevState,
				...action.payload,
			};
		case 'TOGGLE_NOTIFICATION':
			if (action.notificationType === 'All') {
				return {
					...prevState,
					notifications: {
						...Object.keys(prevState.notifications).reduce(
							(newSettings, key) => {
								return { ...newSettings, [key]: !prevState.notifications['All'] };
							},
							{} as typeof prevState.notifications,
						),
					},
				};
			}

			return {
				...prevState,
				notifications: {
					...prevState.notifications,
					[action.notificationType]: !prevState.notifications[action.notificationType],
				},
			};
		case 'TOGGLE_APP_LOCK':
			return {
				...prevState,
				security: {
					...prevState.security,
					biometricLock: !prevState.security.biometricLock,
				},
			};
		default:
			return prevState;
	}
}

export type Action =
	| { type: 'LOAD_SETTINGS'; payload: Settings }
	| { type: 'TOGGLE_NOTIFICATION'; notificationType: NotificationType }
	| { type: 'TOGGLE_APP_LOCK' };
